import { IAppRootState } from '@microsoft/portal-app/lib/redux/modules/root';
import { IRootUserState } from '@microsoft/portal-app/lib/User/models';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { push } from 'connected-react-router';
import { AccountActions, IAccountState, IRootAccountState } from '../Account/models';
import { Header } from './Header';
import { IHeaderProps } from './Header.types';
import { IOrganization } from '@iamexperiences/suite-header/lib-commonjs/SuiteHeader';
type StateProps = Pick<
  IHeaderProps,
  'navBarData' | 'organizations' | 'hasP2License' | 'hasError' | 'currentOrganizationDisplayName'
>;

type DispatchProps = Pick<
  IHeaderProps,
  'getNavBarData' | 'getCurrentOrganization' | 'getOrganizations' | 'manageOrganizationsLinkOnClick'
>;

const mapStateToProps = (state: IRootAccountState & IAppRootState & IRootUserState): StateProps => {
  const { navBarData, organizations, hasP2License, hasError, currentOrgDisplayName, currentOrgId } = state.account;
  const organizationArray: IOrganization[] =
    !organizations.value || organizations.value.length === 0
      ? [{ tenantId: currentOrgId, displayName: currentOrgDisplayName, isCurrent: true, isHome: false }]
      : organizations.value;

  return {
    navBarData,
    currentOrganizationDisplayName: currentOrgDisplayName,
    organizations: { ...organizations, value: organizationArray },
    hasError,
    hasP2License,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<IAccountState>): DispatchProps => {
  return {
    getNavBarData: (token: string) => dispatch({ type: AccountActions.getNavBarData, payload: token }),
    getCurrentOrganization: () => dispatch({ type: AccountActions.getCurrentOrganization }),
    getOrganizations: () => dispatch({ type: AccountActions.getOrganizations }),
    manageOrganizationsLinkOnClick: () => dispatch(push('/organizations')),
  };
};

export const ConnectedHeader = connect(mapStateToProps, mapDispatchToProps)(Header);
